import { useEffect, useRef } from "react";
import { customFieldsRequest } from "./api";

const useSurfaceAcknowledgement = ({
  teamId,
  token,
  enabled,
  oncePerVisit = false,
}) => {
  const lastAcknowledged = useRef(null);
  const acknowledgementKey = oncePerVisit ? String(teamId) : token;
  useEffect(() => {
    if (!enabled || !token || lastAcknowledged.current === acknowledgementKey) {
      return;
    }
    lastAcknowledged.current = acknowledgementKey;
    customFieldsRequest({
      teamId,
      path: "/custom_fields/surface_views",
      method: "POST",
      body: { context: token },
    }).catch(() => {
      // A failed acknowledgement never triggers replay or blocks the rendered surface.
    });
  }, [teamId, token, enabled, acknowledgementKey]);
};

export default useSurfaceAcknowledgement;
